import { get } from '@/lib/api';

export type AnalyticsPeriod = '7d' | '30d' | '90d' | 'all';

export type FunnelStatus = 'NEW' | 'CONFIRMED' | 'SHIPPED' | 'DELIVERED' | 'REJECTED' | 'CANCELLED';

export interface Analytics {
  period: AnalyticsPeriod;
  range: { from: string | null; to: string | null };
  kpi: {
    turnover: number; // копейки, оборот живых заказов
    revenueDelivered: number; // копейки, доставлено
    ordersCount: number;
    deliveredCount: number;
    avgCheck: number; // копейки
    uniqueEstablishments: number;
    repeatRate: number; // %
  };
  funnel: Record<FunnelStatus, number>;
  series: { date: string; orders: number; turnover: number }[];
  topProducts: { name: string; unit: string; quantity: number; sum: number }[];
  topEstablishments: { name: string; ordersCount: number; sum: number }[];
}

export const getAnalytics = (params: { period: AnalyticsPeriod; from?: string; to?: string }) =>
  get<Analytics>('/analytics', params);
